// extracted by mini-css-extract-plugin
export default {"accessContainer":"Accessibility_accessContainer__Q+5ok","accessTitle":"Accessibility_accessTitle__ocorB","link":"Accessibility_link__9NWy+"};